import commonMutations from '@/store/data/common/mutations'
import Vue from 'vue'
import { keyBy } from 'lodash'

export default {
    ...commonMutations,

    setCollection(state, data) {
        Vue.set(state, 'collection', keyBy(data, 'crossId'))
    }
}
